export default __webpack_public_path__ + "static/media/logo-ae-amazon.3567dd7e.svg";